<template>
	<div class="purchase-product">

		<div class="two-part-product-form">
			<Loader :loading="loading" />

			<article class="left-side">

				<div class="product-info-and-form">

					<button @click="$router.push({name:'pricing'})">
						<i class="icon icon-arrow-left"></i> Back
					</button>
					<header>
						<label>{{product.product_name}}</label>
						<h1>${{displayedPrice}}</h1>
						<p v-if="appliedPromo">Promo Applied &check;</p>
					</header>


					<div class="promo-code">
						<button v-if="!applyingPromo && !appliedPromo" @click="promoClick">
							Enter Sponsor Code
						</button>
						<input v-if="applyingPromo" @keydown.enter="checkPromo" v-model="paymentInfo.promo_code" size>
						<button v-if="applyingPromo" @click="checkPromo">
							Apply Sponsor Code
						</button>

						<input v-if="appliedPromo" v-model="paymentInfo.promo_code" class="success" disabled size>

					</div>
				</div>
			</article>

			<article class="right-side">
				<h1 v-if="promoLicense" style="margin-bottom: 1em;">Sponsor License</h1>
				<h1 v-else>Payment</h1>
				<form @submit.prevent>

					<div v-if="!promoLicense" class="payment-options">
						<input v-model="paymentType" value="card" type="radio" id="type-card" />
						<label for="type-card">Credit Card</label>
						<input v-model="paymentType" value="paypal" type="radio" id="type-paypal" />
						<label for="type-paypal">PayPal</label>
					</div>

					<div class="license-info">
						<!-- This input group is absolutely overkill for these fields.. -->
						<!-- But we are using it so they have the exact same behavior as the card info fields -->
						<div class="input-group">
							<label>
								Name on License <span ref="licenseNameError"></span>
							</label>
							<section>
								<div>
									<input v-model="paymentInfo.name" @blur="checkLicenseName" ref="licenseName" />
								</div>
							</section>

						</div>



					</div>

					<div v-if="user.kolkinid && user.kolkinid != ''" class="input-group">
						<label>
							Email address <i @click="signout" class="icon icon-close"></i> <span
								ref="emailError"></span>
						</label>
						<section>
							<div>
								<input v-model="user.email" :disabled="true" placeholder="Email" ref="email">
							</div>
						</section>
					</div>
					<div v-else class="input-group">
						<label>
							Email address <span ref="emailError"></span>
						</label>
						<section>
							<div>
								<input @click="focusEmail" @blur="checkAndValidateEmail"
									@keydown.tab.prevent="focusRightSide" v-model="paymentInfo.email"
									placeholder="Email" ref="email">
							</div>
						</section>
					</div>

					<div class="card-info" :class="{ 'hidden-form': paymentType == 'paypal' || promoLicense }">
						<div class="input-group card-input">
							<label>
								Card Information
								<span ref="cardInfoError"></span>
							</label>
							<section>
								<div>
									<input v-model="paymentInfo.cardNumber" @blur="checkCardNumber" v-mask="'#### #### #### ####'" ref="cardNumber" />
									<div v-if="paymentInfo.cardNumber == ''" class="card-icons">
										<!-- replace these links or images with what we want -->
										<img src="@/assets/img/cc-visa.svg">
										<img src="@/assets/img/cc-mc.svg">
										<img src="@/assets/img/cc-amex.svg">
									</div>

								</div>
								<div class="form-split">
									<input v-model="paymentInfo.expiration" @blur="checkExp" v-mask="'##/##'"
										placeholder="MM / YY" ref="exp" />
									<input v-model="paymentInfo.cardCVV" @blur="checkCVV" v-mask="'####'"
										placeholder="CVC" ref="cvv" />
									<div v-if="paymentInfo.cardCVV == ''" class="card-icons">
										<!-- replace this whole image with what we want -->
										<img style="height: 1rem; margin-right:2px;" src="@/assets/img/credit-card.svg">
									</div>
								</div>
							</section>

						</div>
						<div class="input-group">
							<label>
								Cardholder name
								<span ref="nameError"></span>
							</label>
							<section>
								<div class="form-split">
									<input v-model="paymentInfo.firstName" @blur="checkFirstName"
										placeholder="First Name" ref="firstName" />
									<input v-model="paymentInfo.lastName" @blur="checkLastName" placeholder="Last Name"
										ref="lastName" />
								</div>
							</section>

						</div>

						<div class="input-group">
							<label>
								Address
								<span ref="addressError"></span>
							</label>
							<section>
								<div class="form-split-address">
									<input v-model="paymentInfo.address" @blur="checkAddress" ref="address"
										placeholder="Street Address" />
									<input v-model="paymentInfo.zipCode" @blur="checkZip" ref="zipCode"
										placeholder="ZIP" v-mask="'#####'" maxlength="5" />
								</div>
							</section>

						</div>
					</div>

					<button v-if="paymentType == 'card'" @click="onSubmit">
						Pay
					</button>
					<button v-else-if="promoLicense" @click="onSubmitPromo">
						Active License
					</button>
					<button v-else @click="onSubmitPaypal">
						Pay with PayPal
					</button>

				</form>

			</article>

		</div>
	</div>
</template>

<script>
import Loader from "@/components/base/Loader";
import axios from "axios";
import Validation from "@/mixins/Validation";
import CreditCardType from "@/mixins/CreditCardType";
import Utililty from "@/mixins/Utility";
import qs from "qs";
import store from "@/store";
import {
	mapGetters
} from 'vuex';
export default {

	name: "PurchaseProduct",

	mixins: [
		CreditCardType,
		Validation,
		Utililty
	],

	components: {
		Loader,
	},

	beforeRouteEnter(to, from, next) {

		store.dispatch("loadProduct", to.params.product).then(function () {
			next();
		})

	},

	data() {
		return {
			loading: false,

			paymentInfo: {
				name: "",

				product_id: "",
				email: "",

				creditCardType: "",
				firstName: "",
				lastName: "",
				cardNumber: "",
				cardCVV: "",
				expiration: "",
				expMonth: "",
				expYear: "",

				address: "",
				zipCode: "",
			},
			finalChecking: false,
			validatedFields: {},
			paymentType: "card",
			currentPromo: {},
			applyingPromo: false,
			appliedPromo: false,
			promoLicense: false,
		}
	},

	props: {
		type: {
			type: String,
		}
	},

	methods: {

		goBack(){
			window.location = "/";
		},

		promoClick() {
			this.applyingPromo = true;
		},

		focusEmail() {
			//this function is here because of a weird safari bug
			setTimeout(() => {
				this.$refs.email.focus();
			}, 0);

		},

		focusRightSide() {
			if (this.paymentType == "card") {
				this.$refs.cardNumber.focus();
			} else {
				//this.$refs.firstName.focus();
			}
		},

		onSubmit() {
			if (!this.appliedPromo) {
				this.paymentInfo.promo_code = "";
			}
			this.finalChecking = true;
			if (!(this.checkLicenseName() &

				this.checkAndValidateEmail() &

				this.checkFirstName() &
				this.checkLastName() &

				this.checkCardNumber() &
				this.checkCVV() &
				this.checkExp() &

				this.checkAddress() &
				this.checkZip()
			)) {

				return;
			}
			this.paymentSubmit();
		},

		onSubmitPaypal() {
			if (!this.appliedPromo) {
				this.paymentInfo.promo_code = "";
			}
			this.finalChecking = true;
			if (!(this.checkLicenseName() &
				this.checkAndValidateEmail()
			)) {
				return;
			}
			this.paypalSubmit();
		},

		paypalSubmit() {
			this.loading = true;
			var temp = this;
			if (this.user.kolkinid) {
				this.paymentInfo.email = this.user.email;
			}

			var obj = {
				email: this.paymentInfo.email,
				name: this.paymentInfo.name,
			}
			axios.post("/api/paypal/express", {
				product_id: this.product.product_id,
				promo_code: this.paymentInfo.promo_code,
				custom: obj
			}).then(function (response) {
				var token = response.data.token;
				if (process.env.NODE_ENV === 'production') {
					window.location = "https://www.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" + token + "&useraction=commit";
				} else {
					window.location = "https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" + token + "&useraction=commit";
				}
			}).catch(() => {
				this.loading = false;
				var toastInstance = temp.$toasted.show('Failed to create checkout.', {
					duration: "3000",
					className: "toast-danger",
					position: "top-center"
				});
			})
		},

		paymentSubmit() {
			var expirationSplit = this.paymentInfo.expiration.split("/");

			if (this.user.kolkinid) {
				this.paymentInfo.email = this.user.email;
			}

			var paymentInfoPackage = {
				cardNumber: this.paymentInfo.cardNumber.replace(/\s/g, ''),
				creditCardType: this.getCardType(this.paymentInfo.cardNumber.replace(/\s/g, '')),
				cardCVV: this.paymentInfo.cardCVV,
				expMonth: expirationSplit[0],
				expYear: expirationSplit[1],
				product_id: this.product.product_id,
				email: this.paymentInfo.email,
				name: this.paymentInfo.name,
				firstName: this.paymentInfo.firstName,
				lastName: this.paymentInfo.lastName,
				address: this.paymentInfo.address,
				zipCode: this.paymentInfo.zipCode,
				promo_code: this.paymentInfo.promo_code,
			}

			var temp = this;
			this.loading = true;
			axios.post("/api/pay", paymentInfoPackage).then(function (response) {
				temp.loading = false;

				temp.$router.push({
					name: 'payment-confirm',
					params: {
						key: response.data.license_key
					}
				})

			}).catch(function (error) {
				temp.loading = false;
				if(error.response){
					var toastInstance = temp.$toasted.show(error.response.data, {
						duration: "6000",
						className: "toast-danger",
						position: "top-center"
					});
				}else {
					var toastInstance = temp.$toasted.show('There was an error processing your payment.', {
						duration: "6000",
						className: "toast-danger",
						position: "top-center"
					});
				}
			});
		},


		onSubmitPromo(){

			var promoInfo = {
				code: this.paymentInfo.promo_code,
				product_id: this.product.product_id,
				email: this.paymentInfo.email,
				licensee: this.paymentInfo.name,
			}

			if (this.user.kolkinid) {
				promoInfo.email = this.user.email;
			}

			axios.post("/api/promo/activate", promoInfo).then((response) => {
				if(response.data.product_id == this.product.product_id){
					var promo = response.data;
					this.$router.push({
						name: 'payment-confirm',
						params: {
							key: promo.license_key,
							is_trial: "trial",
						}
					})
				}
			})
		},

		checkPromo() {
			axios.get("/api/promo/check", {
				params: {
					code: this.paymentInfo.promo_code,
					product_id: this.product.product_id
				}
			}).then((response) => {
				console.log(response)
				var promo = response.data;

				if (promo.product_id == this.product.product_id) {
					this.appliedPromo = true;
					this.currentPromo = promo;
				}

				if(promo.creates_trial=="t"){
					this.promoLicense = true;
					this.paymentType = "promo";
				}

				this.applyingPromo = false;
				if (!this.appliedPromo) {
					this.paymentInfo.promo_code = "";
					alert("Invalid Promo Code")
				}
			})
		},

		signout() {
			this.$store.dispatch("signout")
		},

		checkLicenseName() {
			if (!(this.notEmpty(this.paymentInfo.name))) {
				this.applyError("licenseName", "REQUIRED");
				return false;
			}

			this.clearError("licenseName");
			return true;
		},

		checkAndValidateEmail() {

			if (this.user.kolkinid) {
				return true;
			}

			if (!(this.notEmpty(this.paymentInfo.email))) {
				this.applyError("email", "REQUIRED");
				return false;
			}

			if (!this.validEmail(this.paymentInfo.email)) {
				this.applyError("email", "Email address is invalid", true);
				return false;
			}

			this.clearError("email");

			return true;
		},

		checkCardNumber() {

			if (!(this.notEmpty(this.paymentInfo.cardNumber))) {
				this.applyCertainError("cardNumber", "cardInfoError", "REQUIRED");
				return false;
			}

			if (!this.validCard(this.paymentInfo.cardNumber.replace(/\s/g, ''))) {
				this.applyCertainError("cardNumber", "cardInfoError", "Invalid Card", true);
				return false;
			}

			this.clearCertainError("cardNumber", "cardInfoError");
			return true;
		},

		checkExp() {
			var expirationSplit = this.paymentInfo.expiration.split("/");
			this.paymentInfo.expMonth = expirationSplit[0];
			this.paymentInfo.expYear = expirationSplit[1];

			if (!(this.notEmpty(this.paymentInfo.expiration))) {
				this.applyCertainError("exp", "cardInfoError", "REQUIRED");
				return false;
			}

			if (!this.validCardExp(this.paymentInfo.expMonth, this.paymentInfo.expYear)) {
				this.applyCertainError("exp", "cardInfoError", "Invalid Expiration", true);
				return false;
			}

			this.clearCertainError("exp", "cardInfoError");
			return true;
		},

		checkCVV() {

			if (!(this.notEmpty(this.paymentInfo.cardCVV))) {
				this.applyCertainError("cvv", "cardInfoError", "REQUIRED");
				return false;
			}

			if (!this.validCVV(this.paymentInfo.cardCVV)) {
				this.applyCertainError("cvv", "cardInfoError", "Invalid CVV", true);
				return false;
			}

			this.clearCertainError("cvv", "cardInfoError");
			return true;
		},

		checkFirstName() {
			if (!(this.notEmpty(this.paymentInfo.firstName))) {
				this.applyCertainError("firstName", "nameError", "REQUIRED");
				return false;
			}
			this.clearCertainError("firstName", "nameError");
			return true;
		},

		checkLastName() {
			if (!(this.notEmpty(this.paymentInfo.lastName))) {
				this.applyCertainError("lastName", "nameError", "REQUIRED");
				return false;
			}
			this.clearCertainError("lastName", "nameError");
			return true;
		},

		checkAddress() {
			if (!(this.notEmpty(this.paymentInfo.address))) {
				this.applyCertainError("address", "addressError", "REQUIRED");
				return false;
			}

			if (!this.validAddress(this.paymentInfo.address)) {
				this.applyCertainError("address", "addressError", "Invalid Address", true);
				return false;
			}

			this.clearCertainError("address", "addressError");
			return true;
		},

		checkZip() {

			if (!(this.notEmpty(this.paymentInfo.zipCode))) {
				this.applyCertainError("zipCode", "addressError", "REQUIRED");
				return false;
			}

			if (!this.validZip(this.paymentInfo.zipCode)) {
				this.applyCertainError("zipCode", "addressError", "Invalid ZIP", true);
				return false;
			}

			this.clearCertainError("zipCode", "addressError");
			return true;
		},

		applyError(ref, message, immediate) {
			if (!this.validatedFields[ref] && !this.finalChecking && !immediate) {
				return;
			}
			this.$refs[ref].classList.add("error");
			this.$refs[ref + "Error"].innerHTML = message;
		},

		clearError(ref) {
			this.validatedFields[ref] = true;
			this.$refs[ref].classList.remove("error");
			this.$refs[ref + "Error"].innerHTML = "";
		},

		applyCertainError(ref, ref2, message, immediate) {
			if (!this.validatedFields[ref] && !this.finalChecking && !immediate) {
				return;
			}
			this.$refs[ref].classList.add("error");
			this.$refs[ref2].innerHTML = message;
		},

		clearCertainError(ref, ref2) {
			this.validatedFields[ref] = true;
			this.$refs[ref].classList.remove("error");
			this.$refs[ref2].innerHTML = "";
		},
	},

	computed: {
		displayedPrice() {
			var result = this.product.product_price;
			if (this.currentPromo && this.currentPromo.discount_amount) {
				result = result - this.currentPromo.discount_amount;
			}
			return this.numberWithCommas(result);
		},
		...mapGetters(["user", "product"])
	},
}
</script>

<style lang="less" scoped>
@import (reference) "@/assets/less/style.less";

.purchase-product {
	--payment-form-border: var(--color-gray-4);

	padding: 2em 2.5em;

}

.two-part-product-form {
	label {
		font-size: 0.8em;
		color: var(--color-gray-6);
		display: flex;
		align-items: flex-end;

		&>span {
			margin-left: auto;
			color: var(--color-red-8);
			font-size: 0.8em;
		}
	}

	.input-group {
		//there are several funny styles here with borders and "first-of/last-of" type selectors
		//the reason these are styled this way is to make the outline around the card inputs
		//work while the inputs are all bunched together
		//doing it another way makes it look like the outline is hidden or a border is missing
		// -Matt

		margin-bottom: 1em;

		section {
			border: 1px solid var(--payment-form-border);
			border-radius: var(--radius-2);
			box-shadow: 0px 6px 6px -4px var(--color-gray-3);

			&>:first-child {

				border-bottom: 1px solid var(--payment-form-border);

				input {
					z-index: 3;

					&:first-of-type {
						border-top-left-radius: var(--radius-2);
					}

					&:last-of-type {
						border-top-right-radius: var(--radius-2);
					}
				}
			}

			&>:last-child {

				border-bottom: none;

				input {
					&:first-of-type {
						border-bottom-left-radius: var(--radius-2);
					}

					&:last-of-type {
						border-bottom-right-radius: var(--radius-2);
					}
				}
			}

		}

		input {
			border: none;

			border-radius: 0;
			outline-offset: 0px;
			font-size: 0.9em;

			&::placeholder {
				color: var(--color-gray-5);
			}

			transition: border 100ms linear;
			transition: outline 50ms linear;

			&:focus {
				box-shadow: 0px 0px 2px 0px var(--color-gray-8);
				outline-offset: -1px;
			}

			&:nth-child(1) {
				border-right: 1px solid var(--payment-form-border);

				&:last-of-type {
					border-right: none;
				}
			}

			&.error {
				box-shadow: 0px 0px 0px 1px var(--color-red-8);
			}
		}
	}

	.product-info-and-form {

		margin-bottom: 2em;

		&>button {
			border: none;
			margin-left: -1.5em;
			margin-bottom: 1.5em;
		}

		header {
			margin-bottom: 1.5em;

			label {
				margin: 0;
			}

			h1 {
				margin: 0;
				font-size: 1.75em;
				font-weight: 500;
			}

			p {
				color: var(--color-gray-6);
				font-size: 0.8em;
			}
		}

		h2 {
			font-size: 1.2em;
			font-weight: 400;
		}

		.promo-code {
			display: flex;
			align-items: center;

			&>button {
				border: none;
				color: var(--color-blue-9);
				padding-left: 0;

			}

			input {
				width: 10em;
				margin: 0 1rem 0 0;
				border: 1px solid var(--color-blue-1);
				box-shadow: none;
				background-color: var(--color-blue-0);

				&.success {
					opacity: 0.5;
				}
			}
		}
	}

	.right-side {
		form {
			&>button {
				width: 100%;
				margin-top: 1.5em;
				padding: 0.75rem 0.75rem;
				border: none;
				background-color: var(--color-blue-9);
				color: var(--color-white);
			}
		}

		h1 {
			margin: 0;
		}

		.payment-options {
			margin-bottom: 1.5em;

			label {
				margin: 0;
				width: 8em;
			}
		}
	}

	.card-input {


		section>div {
			position: relative;

			.card-icons {
				position: absolute;
				right: 0;
				top: 0;
				bottom: 0;
				display: flex;
				align-items: center;
				padding-right: 0.75rem;

				img {
					margin-right: 0.25em;
					height: .75em;
					width: auto;
				}

			}

		}

	}

	.card-info {
		transition: height 200ms ease-in-out;
		height: 16em;
		margin: 0;
		overflow: hidden;
	}

	.hidden-form {
		height: 0;

		margin: 0;
	}
}

.form-split {
	display: flex;

	input:first-child {
		.make-col(6);
	}

	input:last-child {
		.make-col(6);
	}
}

.form-split-address {
	display: flex;

	input:first-child {
		.make-col(9);
		padding-right: 0.5rem;
	}

	input:last-child {
		.make-col(3);
	}
}

@media @breakpoint-md-up {
	.purchase-product {
		padding: 2em 8em;
	}
}

@media @breakpoint-lg-up {

	.purchase-product {
		padding: 0;
	}

	.two-part-product-form {

		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		min-height: 800px;
		display: flex;

		article {
			flex: 1 1 0px;
			padding: 5em;
		}

		.left-side {

			display: flex;

			.product-info-and-form {
				width: 25em;
				margin-left: auto;
			}
		}

		.right-side {
			border-left: 1px solid var(--color-gray-3);
			box-shadow: -5px 0px 40px 1px var(--color-gray-3);

			form {
				width: 25em;
			}
		}
	}

}
</style>
